/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';
import Metrics from '@spotahome/soyuz-metrics';
import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { Modal, ModalHeader, CircleCheckedIcon } from '@spotahome/ui-library';
import Cookies from 'universal-cookie';

import { COOKIE_VALUE_PROPOSITION_MODAL } from '../../constants';

import BulletPoints from './BulletPoints';

import './ValuePropositionModal.scss';

const expireNineMonthsFromNow = () => {
  const timestamp = new Date().getTime();
  const expiration = timestamp + 1000 * 60 * 60 * 24 * 30 * 9;
  return new Date(expiration);
};

const MODAL_STEPS = {
  1: {
    title: 'search.value-proposition-modal.step1-title',
    renderMedia: () => (
      <picture className="value-proposition-modal__images-picture">
        <img
          alt={trans('search.value-proposition-modal.step1-title')}
          src={getResourcePath('/images/value-proposition/modal-step-1.jpg')}
        />
        <div className="value-proposition-modal__images-first">
          {trans('search.value-proposition-modal.step1.image-text')}
        </div>
      </picture>
    )
  },
  2: {
    title: 'search.value-proposition-modal.step2-title',
    renderMedia: () => (
      <video
        className="value-proposition-modal__images-video"
        data-test="value-proposition-modal-animation"
        muted
        loop
        playsInline
        preload="auto"
        autoPlay
      >
        <source
          src={getResourcePath('/videos/VP-modal.mp4')}
          type="video/webm"
        />
      </video>
    )
  },
  3: {
    title: 'search.value-proposition-modal.step3-title',
    renderMedia: () => (
      <picture className="value-proposition-modal__images-picture">
        <img
          alt={trans('search.value-proposition-modal.step3-title')}
          src={getResourcePath('/images/value-proposition/modal-step-3.jpg')}
        />
        <div className="value-proposition-modal__images-third">
          {trans('search.value-proposition-modal.step3.image-text')}
        </div>
      </picture>
    )
  },
  4: {
    title: 'search.value-proposition-modal.step4-title',
    renderMedia: () => (
      <picture className="value-proposition-modal__images-picture">
        <img
          alt={trans('search.value-proposition-modal.step4-title')}
          src={getResourcePath('/images/value-proposition/modal-step-4.jpg')}
        />
        <div className="value-proposition-modal__images-forth">
          <CircleCheckedIcon className="value-proposition-modal__images-forth-icon" />
          {trans('search.value-proposition-modal.step4.image-text')}
        </div>
      </picture>
    )
  }
};

const ValuePropositionModal = () => {
  const [stepNumber, setStepNumber] = useState(1);
  const [isModalOpen, setModalIsOpen] = useState(true);
  const cookies = new Cookies();

  useEffect(
    () =>
      cookies.set(COOKIE_VALUE_PROPOSITION_MODAL, true, {
        path: '/',
        expires: expireNineMonthsFromNow()
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const MODAL_STEPS_LENGTH = Object.keys(MODAL_STEPS).length;

  const decreaseStep = () => stepNumber > 1 && setStepNumber(stepNumber - 1);

  const increaseStep = () => {
    if (stepNumber < MODAL_STEPS_LENGTH) {
      setStepNumber(stepNumber + 1);
      Metrics.ga.sendEvent(
        'Search',
        'value-proposition-modal_next-step',
        stepNumber
      );
    }
  };

  const goToStep = desiredStep =>
    stepNumber !== desiredStep && setStepNumber(desiredStep);

  const handleModalClose = () => {
    Metrics.ga.sendEvent('Search', 'value-proposition-modal_close', 'close');
    setModalIsOpen(false);
  };

  return (
    <Modal
      size="big"
      className="value-proposition-modal"
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
    >
      <ModalHeader
        className="value-proposition-modal__header"
        onRequestClose={handleModalClose}
        data-test="value-proposition-modal-close-btn"
      />
      <div className="value-proposition-modal__images">
        {MODAL_STEPS[stepNumber].renderMedia()}
      </div>

      <div
        className="value-proposition-modal__content"
        data-test="valuePropositionModal"
      >
        <h1 className="value-proposition-modal__content-title">
          {trans(MODAL_STEPS[stepNumber].title)}
        </h1>

        <div className="value-proposition-modal__content-footer">
          <p
            className="value-proposition-modal__content-cta value-proposition-modal__content-cta--prev"
            onClick={decreaseStep}
          >
            {stepNumber > 1 ? trans('search.value-proposition.previous') : ''}
          </p>
          <div className="value-proposition-modal__content-bullets-container">
            <BulletPoints
              totalSteps={MODAL_STEPS_LENGTH}
              currentStep={stepNumber}
              handleOnClick={goToStep}
            />
          </div>
          <p
            className="value-proposition-modal__content-cta value-proposition-modal__content-cta--next"
            onClick={
              stepNumber < MODAL_STEPS_LENGTH ? increaseStep : handleModalClose
            }
          >
            {stepNumber < MODAL_STEPS_LENGTH
              ? trans('search.value-proposition.next')
              : trans('search.value-proposition.start')}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default ValuePropositionModal;
